import React from "react";
import ShiftDropDrawer from "../../shared/shiftswaps/ShiftDropDrawer";
import { getCardColor2 } from "../../../../../helpers/helpers";
import ShiftNoteInline from "../../shared/shiftswaps/ShiftNoteInline";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function ScheduleSelectedShift(props) {
  function handleAddToPoolPress(note) {
    props.drop_shift(props.shift.id, null, note);
  }

  const shiftInfo = props.shift;

  let badgeText = "";
  if (shiftInfo?.badge === "is_pending_drop_by_user") {
    badgeText = "Drop Requested";
  } else if (
    shiftInfo?.badge === "is_trade_by_user_pending_employee_response"
  ) {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_by_user_pending_manager_response") {
    badgeText = "Offered Trade";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_self_response") {
    badgeText = "";
  } else if (shiftInfo?.badge === "is_trade_to_user_pending_manager_response") {
    badgeText = "";
  } else if (shiftInfo?.badge === "is_pending_pickup_by_user") {
    badgeText = "";
  } else {
    badgeText = "";
  }

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const shiftCardColor = getCardColor2(
    props.roleId?.id,
    props.roleNames,
    false
  );

  return (
    <>
      <div
        className="w-full rounded-xl bg-violet-50 border border-violet-200 hover:bg-violet-100 cursor-pointer px-4 py-3.5 relative mt-3 transition-colors"
        onClick={toggleDrawer(true)}
      >
        <div className="flex flex-row items-center relative">
          <div className="flex-1">
            <p className="text-violet-600 text-xs font-semibold">Your shift</p>
            <p className="text-slate-900 font-bold text-lg mt-0.5">
              {props.shiftStartNumber}{props.shiftStartLetters?.toLowerCase() || ""} - {props.shiftEndNumber}{props.shiftEndLetters?.toLowerCase() || ""}
            </p>
            <p className="text-sm text-slate-500 mt-0.5">
              {props.station
                ? props.station
                : props.role
                ? props.role
                : props.roleType}{" "}
              &mdash; {props.location}
            </p>
          </div>
          <div className="text-slate-400">
            <ChevronRightIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
          </div>
          {/* Anchored to the header row (same spot as before) so it never covers the note */}
          {badgeText && (
            <div className="bg-amber-50 px-2 py-0.5 rounded-full absolute -bottom-1.5 -right-2 border border-amber-200">
              <p className="text-amber-700 text-xs">{badgeText}</p>
            </div>
          )}
        </div>
        <ShiftNoteInline note={props.note} />
      </div>
      <ShiftDropDrawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        setDrawerOpen={setDrawerOpen}
        shiftInfo={shiftInfo}
        badgeText={badgeText}
        date={props.date}
        firstName={props.firstName}
        lastName={props.lastName}
        isDateInPast={props.isDateInPast}
        shiftStartNumber={props.shiftStartNumber}
        shiftStartLetters={props.shiftStartLetters}
        shiftEndNumber={props.shiftEndNumber}
        shiftEndLetters={props.shiftEndLetters}
        role={props.role}
        station={props.station}
        roleType={props.roleType}
        break={props.break}
        location={props.location}
        handleAddToPoolPress={handleAddToPoolPress}
        drop_shift={props.drop_shift}
        trade_shift={props.trade_shift}
        rescind_drop_shift={props.rescind_drop_shift}
        rescind_trade_shift={props.rescind_trade_shift}
        notMyUpcomingShifts={props.notMyUpcomingShifts}
        shiftCardColor={shiftCardColor}
        roleNames={props.roleNames}
        note={props.note}
      />
    </>
  );
}

export default ScheduleSelectedShift;
